// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_ScheduleBulkMessagesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for schedule_bulk_messages endpoint
 * Returns bulk scheduling results with individual message statuses
 */
import type { MensagensProgramadasLote_BulkSendResultRow } from './MensagensProgramadasLote_BulkSendResultRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MensagensProgramadasLote_ScheduleBulkMessagesResponseDados {
results: MensagensProgramadasLote_BulkSendResultRow[]
success_count: number
error_count: number
bulk_id: number
}

export type MensagensProgramadasLote_ScheduleBulkMessagesResponse = ApiResponse<MensagensProgramadasLote_ScheduleBulkMessagesResponseDados>;

registerResponseContract('MensagensProgramadasLote_ScheduleBulkMessagesResponse', {
  results: {
    type: 'array',
    required: true,
    items: {
      success:     { type: 'boolean', required: true },
      cliente_id:  { type: 'number',  required: true },
      mensagem_id: { type: 'number',  required: false },
      erro:        { type: 'string',  required: false },
    },
  },
  success_count: { type: 'number',  required: true },
  error_count:   { type: 'number',  required: true },
  bulk_id:       { type: 'number',  required: true },
})
